import Router from 'Router/Router.jsx';

export default Router;
